import { render, staticRenderFns } from "./uusi-virkailija-form.vue?vue&type=template&id=5d06468d&"
import script from "./uusi-virkailija-form.vue?vue&type=script&lang=ts&"
export * from "./uusi-virkailija-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports